/**
 * Props that make a non-interactive element behave like a link: focusable, announced
 * as a link, and activated by click or Enter. Space deliberately does not activate it,
 * matching native links. Enter bubbling up from a nested control is ignored so that,
 * for example, a video button inside the element does not also trigger navigation.
 * Not for table rows: role="link" would replace their row semantics.
 */
export const linkKeyboardProps = (onActivate) => ({
  role: "link",
  tabIndex: 0,
  onClick: onActivate,
  onKeyDown: (event) => {
    if (event.target !== event.currentTarget) return;
    if (event.key !== "Enter") return;
    onActivate(event);
  },
});
